import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule],
  selector: 'app-claims-need-help',
  templateUrl: './claims-need-help.component.html',
  styleUrls: ['./claims-need-help.component.scss'],
})
export class ClaimsNeedHelpComponent implements OnInit {
  isAcmic: boolean;
  constructor(private acmicService: AcmicService) {}

  ngOnInit() {
    this.detectStateCode();
  }
  detectStateCode() {
    this.isAcmic = this.acmicService.isACMIC();
  }
}
